module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(konto do wysyłania)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.test
    }
  }, [_vm._v("Testuj konto")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj konto")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Nazwa wysyłającego wiadomości\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.from_name) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Adres e-mail z jakiego będą wychodzić wiadomości\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.from_address) + "\n              ")])])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Konto smtp\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Host\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.host) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Port\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.port) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Host\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.host) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Nazwa użytkownika\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.username) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Hasło\n              ")]), _vm._v(" "), _c('td', [_c('ui-button', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_vm._v("pokaż / zakryj")]), _vm._v(" "), (_vm.showPassword) ? _c('span', [_vm._v(_vm._s(_vm.item.password))]) : _vm._e(), _vm._v(" "), (!_vm.showPassword) ? _c('span', [_vm._v("****")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Limit wysyłania\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Limit wysyłanych wiadomości za jednym razem\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.limit) + "\n              ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c734fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/Show.vue
// module id = 250
// module chunks = 0